/*****************************************************************************/
/*  File Name: admindatabaseManagementDialog.js                              */
/*  Date:      September 09, 2025                                            */
/*  Author:    Ben Wakutz                                                    */
/*  Purpose:   Dialog to run a cloud function to make users emails           */
/*             lower case. Runs against entire database.                     */
/*****************************************************************************/

import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from '@mui/material';
import { getFunctions, httpsCallable } from 'firebase/functions';

function DatabaseManagementDialogAdmin({ openDialog, setOpenDialog }) {

    const functions = getFunctions();
    const updateUserEmails = httpsCallable(functions, 'users-updateEmails');
    const [databaseMessage, setDatabaseMessage] = useState("");

    const closeDialog = () => {
        setOpenDialog(false);
    };


    //console.log("Clinic in add user",clinic);

    return (
        <Dialog open={openDialog} onClose={() => closeDialog()} fullWidth={true} maxWidth='sm'>
            <DialogTitle>
                <Grid item xs container>
                    <Grid item xs={11}>
                        <Typography variant='h6'>Database Management</Typography>
                    </Grid>
                    <Grid item xs={1} align='right'>
                        <IconButton onClick={() => closeDialog()}>
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent dividers>
                <Grid item xs container spacing={2} alignItems='center' justify='center'>
                    <Grid item xs={12}>
                        <Typography variant='p'>Update User emails to lowercase.</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant='p'>CAUTION: This will affect all users and could take time.</Typography>
                    </Grid>
                    <Grid item xs={12}>
                       <Button color='primary' onClick={async () => {
                            try {
                            const result = await updateUserEmails();
                            setDatabaseMessage(result.data.message);
                            } catch (error) {
                                console.log(error);
                            setDatabaseMessage("Database update failed: " + error.message);
                            }
                        }}>
                            Update User Emails
                        </Button> 
                    </Grid>
                    <Grid item xs={12}>
                       {databaseMessage && <Typography>{databaseMessage}</Typography>}
                    </Grid>
                    
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid item xs container>
                    <Grid item xs={4}>
                        <Button onClick={() => closeDialog()}>Cancel</Button>
                    </Grid>
                    <Grid item xs={4}>
                        
                    </Grid>
                    <Grid item xs={4} align='right'>
                        
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    );
}

export default DatabaseManagementDialogAdmin;
